var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecathlonAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#3643BA",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.655 22C33.1417 22 20 32.9076 20 41.9754C20 46.6407 23.614 49.0062 28.345 49.0062C31.8275 49.0062 36.0329 47.7577 40.1068 45.2608V27.191C39.0554 29.0308 33.9302 36.5216 29.8563 40.4641C27.7536 42.501 26.1109 43.3552 24.731 43.3552C23.154 43.3552 22.3655 42.3039 22.3655 40.6612C22.3655 33.3676 34.653 23.8398 42.8008 23.8398C46.152 23.8398 48.3203 25.3511 48.3203 28.2423C48.3203 30.8706 46.5462 34.2218 43.4579 37.3101V42.8953C48.846 38.6899 52 33.2361 52 28.8994C51.9343 24.3655 48.386 22 43.655 22Z",
    fill: "#3643BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecathlonAppIcon);
export default __webpack_public_path__ + "static/media/decathlon-app-icon.5a7d6f12b8bebffeaaf4beac501b6dca.svg";
export { ForwardRef as ReactComponent };